import Light from '@/domain/scene/lights/generic/Light.js'

const TRAIN_LIGHT_WIDTH_REL = 0.018
const TRAIN_LIGHT_HEIGHT_REL = 0.06
const TRAIN_LIGHT_INIT_Y_REL = 0.45
const TRAIN_LIGHT_COLOR = 'rgb(128, 191, 255)'
const TRAIN_LIGHT_IMG = require('@/assets/train-light.png')

const TRAIN_LIGHT_IMAGE_WIDTH = 180
const TRAIN_LIGHT_IMAGE_HEIGHT = 180

const TRAIN_LIGHT_CLOCK_PARENT = 'train'

export {
  TRAIN_LIGHT_IMG
}

export default class TrainLight extends Light {
  constructor (elemName, initXRel, clockPos, elemImg = TRAIN_LIGHT_IMG) {
    super(
      elemName,
      TRAIN_LIGHT_WIDTH_REL,
      TRAIN_LIGHT_HEIGHT_REL,
      initXRel,
      TRAIN_LIGHT_INIT_Y_REL,
      TRAIN_LIGHT_COLOR,
      elemImg,
      TRAIN_LIGHT_IMAGE_WIDTH,
      TRAIN_LIGHT_IMAGE_HEIGHT,
      clockPos
    )

    this.clockParent = TRAIN_LIGHT_CLOCK_PARENT
  }
}
